import { SelectItem } from "@radix-ui/react-select";
import { ComponentProps } from "react";

export const SelectButton = (props: Omit<ComponentProps<typeof SelectItem>, "onSelect" | "value">) => {
  return <SelectItem {...props} onSelect={(e) => e.preventDefault()} value="" />;
};
